class PlungeMap extends HTMLElement {
  constructor() {
    super();
    this.initialLocation = {
      "Name": "PLUNGE HQ",
      "lat": 38.9066,
      "lng": -121.336991
    }
    this.mapMarkers = [];
    this.mapEl = this.querySelector('[data-map]');
    this.form = this.querySelector('form');
    this.init();
  }

  async init() {
    this.initMap(this.initialLocation);

    if(!this.form) {
      console.log('Unable to initialize form.');
      return;
    }

    this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
  }

  async initMap(coordinates) {
    const { Map } = await google.maps.importLibrary('maps');

    if(!this.mapEl) {
      console.error('Map element does not exist.');
      return;
    };

    if(!Map) {
      console.error('Undefined error while trying to create map.');
      return;
    }

    this.mapInstance = new Map(this.mapEl, {
      zoom: 10,
      position: coordinates,
      center: coordinates,
      mapId: 'PLUNGE_MAP'
    });

    const plungeHqZipCode = "95648";
    this.handleMapLocations(plungeHqZipCode);
  }

	async getPlaceId(name, lat, lng) {
		return new Promise((resolve, reject) => {
			const map = new google.maps.Map(document.createElement("div"));
			const service = new google.maps.places.PlacesService(map);

			const request = {
				query: name,
				fields: ["place_id"],
				locationBias: new google.maps.LatLng(lat, lng), // Fixed locationBias
			};

			service.findPlaceFromQuery(request, (results, status) => {
				if (status === google.maps.places.PlacesServiceStatus.OK && results.length) {
					resolve(results[0].place_id);
				} else {
					console.error("Error fetching Place ID:", status);
					resolve(null);
				}
			});
		});
	}



  async addMapMarkers(locations) {
		const { InfoWindow } = await google.maps.importLibrary("maps");

		if (!InfoWindow) {
			console.error('Undefined error while trying to create markers.');
			return;
		}

		if (!this.mapInstance) {
			console.error('Map is not initialized yet');
			return;
		}

		if (!locations?.length) {
			console.error('Unable to create markers for locations');
			return;
		}

		// Create markers popup
		const infoWindow = new InfoWindow();

		// Create map markers
		for (let location of locations) {
			const marker = new google.maps.Marker({
				map: this.mapInstance,
				position: {
					lat: location.ShippingLatitude,
					lng: location.ShippingLongitude,
				},
				title: location.Name,
				gmpClickable: true,
				icon: {
					url: 'https://cdn.shopify.com/s/files/1/0409/5626/4605/files/plunge_map_pin.svg?v=1733417437',
				},
			});

			marker.addListener('click', async () => {
				infoWindow.close();

				const infoWindowHeader = document.createElement('strong');
				infoWindowHeader.innerHTML = marker.title;
				infoWindow.setHeaderContent(infoWindowHeader);

				const placeId = await this.getPlaceId(location.Name, location.ShippingLatitude, location.ShippingLongitude);
				const mapsUrl = placeId
					? `https://www.google.com/maps/place/?q=place_id:${placeId}`
					: `https://www.google.com/maps?q=${location.ShippingLatitude},${location.ShippingLongitude}`;

				const infoWindowContent = document.createElement('div');
				infoWindowContent.innerHTML = `
					<p>${[location.ShippingStreet, location.ShippingCity, location.ShippingState, location.ShippingPostalCode]
						.filter(Boolean)
						.join(", ")}</p>
					${location.Phone ? `<a href="tel:${location.Phone}">${location.Phone}</a><br>` : ""}
					${location.Website ? `<a href="${location.Website}" target="_blank">${location.Website}</a><br>` : ""}
					<a href="${mapsUrl}" target="_blank">
						View on Google Maps
					</a>
				`;

				infoWindow.setContent(infoWindowContent);
				infoWindow.open(marker.map, marker);
			});


			this.mapMarkers.push(marker);
		}
	}


  removeMapMarkers() {
    if(!this.mapMarkers?.length) {
      console.error('No marker to remove');
      return;
    }

    while(this.mapMarkers?.length) {
      this.mapMarkers.pop().setMap(null);
    }
  }

  async handleFormSubmit(e) {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    const zipCode = formData.get('zip-code');

    await this.handleMapLocations(zipCode, true);
  }

  async getAddressFromLatLng(lat, lng) {
    const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyCaCQ-BYZM6DrzG1jYanUhirT33_BECsPY`);

    if(!response.ok) {
      console.error('Unable to get address.');
      return;
    }

    const data = await response.json();
    const address = data.results[0].formatted_address;

    return address;
  }

  async handleMapLocations(zipCode, reloadMap = false) {
    const locations = await this.getPlungeLocations();
    if(!locations?.length) {
      console.error('Unable to get locations.');
    }

    const userCoordinates = await this.getCoodinatesFromZip(zipCode);
    if(!userCoordinates?.lat || !userCoordinates?.lng) {
      console.error('Unable to get coodinates from zip code.');
      return;
    }

    let radius = 50;
    let nearbyStores = [];
    while (nearbyStores?.length === 0) {
      nearbyStores = this.getNearbyStores(userCoordinates, locations, radius);
      if(nearbyStores?.length) break;
      radius += 50 ;
    }

    if(!nearbyStores?.length) {
      console.error('Unable to find nearby stores');
    }

    if(reloadMap) {
      await this.reloadMap(userCoordinates, nearbyStores);
    } else {
      await this.addMapMarkers(nearbyStores);
    }
  }

  async getPlungeLocations() {
    if(!this.dataset.locationsUrl) {
      console.error('Invalid locations url.')
      return;
    };

    const response = await fetch(this.dataset.locationsUrl);

    if(!response.ok) {
      console.error('Unable to fetch plunge locations.');
    }

    const locations = await response.json();
    return locations;
  }

  async getCoodinatesFromZip(zipCode) {
    const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURI(zipCode)}&key=AIzaSyCaCQ-BYZM6DrzG1jYanUhirT33_BECsPY`);

    if(!response.ok) {
      console.error('Unable to get coodinates from zip code.');
      return;
    }

    const data = await response.json();
    const location = data.results[0].geometry.location;
    return { lat: location.lat, lng: location.lng };
  }

  getNearbyStores(userCoordinates, locations, distance) {
    const nearbyStores = this.filterStores(userCoordinates.lat, userCoordinates.lng, locations, distance);
    return nearbyStores;
  }

  filterStores(userLat, userLng, stores, radius) {
    const filteredStores = stores.filter(store => {
      const distance = this.calculateDistance(userLat, userLng, store.ShippingLatitude, store.ShippingLongitude);
      return distance <= radius;
    });

    return filteredStores;
  }

  calculateDistance(lat1, lng1, lat2, lng2) {
    const toRad = (value) => value * Math.PI / 180;
    const R = 6371; // Radius of the Earth in km
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
              Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in km
  }

  async reloadMap(coordinates, locations) {
    if(!this.mapInstance) {
      console.error('Map is not initialized.');
      return;
    };

    this.mapInstance.setCenter(coordinates);

    this.removeMapMarkers();
    await this.addMapMarkers(locations);

    await this.fitMap(coordinates);
  }

  async fitMap(locationCoordinates) {
    const { LatLngBounds } = await google.maps.importLibrary("core");

    if(!this.mapMarkers?.length) {
      console.error('Unable to fit map');
      return;
    }

    let bounds = new LatLngBounds();
    for (let i = 0; i < this.mapMarkers.length; i++) {
      bounds.extend(locationCoordinates);
      bounds.extend(this.mapMarkers[i].position);
    }

    this.mapInstance.fitBounds(bounds, 125);
  }
}

if(!customElements.get('plunge-map')) {
  customElements.define('plunge-map', PlungeMap);
}